import { CalooAdminConfig } from "../admin";

const BASE_URL = CalooAdminConfig?.orbbyteApi || import.meta.env.VITE_DATA_URL;
const headers = {
    'Content-Type': 'application/json',
    'Authorization': import.meta.env.VITE_API_ORBBYTE_KEY
};

async function getAdminById({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getAdminById/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getAllChallenges({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getAllChallenges/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getAllIngredients({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getAllIngredients/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getAllRecipes({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getAllRecipes/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getCalooPage({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getCalooPage/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getChallengeById({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getChallengeById/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getCompanies({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getCompanies/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getCompaniesLimit({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getCompaniesLimit/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getCompany({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getCompany/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getCustomerNutriChat({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getCustomerNutriChat/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getDietById({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getDietById/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getDiets({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getDiets/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getDietsLimit({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getDietsLimit/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getFeaturedRecipes({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getFeaturedRecipes/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getFilteredRecipes({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getFilteredRecipes/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getFoodTrackings({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getFoodTrackings/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getIADietQueue({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getIADietQueue/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getIngredientById({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getIngredientById/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getIngredientsByStatus({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getIngredientsByStatus/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getMealTypes({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getMealTypes/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getMilestoneById({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getMilestoneById/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getMilestones({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getMilestones/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getMilestonesByDate({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getMilestonesByDate/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getMilestonesInChallenge({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getMilestonesInChallenge/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getModalPremium({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getModalPremium/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getModalPremiumById({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getModalPremiumById/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getNextDietByUserId({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getNextDietByUserId/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getNutriChat({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getNutriChat/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getNutrichatsForNutritionist({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getNutrichatsForNutritionist/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getOorenjiLevelByLevel({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getOorenjiLevelByLevel/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getPopUps({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getPopUps/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getPromptByName({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getPromptByName/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getRecipeByFbid({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getRecipeByFbid/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getRecipeById({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getRecipeById/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getRecipesByPacks({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getRecipesByPacks/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getRecipesByUser({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getRecipesByUser/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getRedisVersion({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getRedisVersion/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getReferalById({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getReferalById/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getTracking({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getTracking/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getTrackingByKey({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getTrackingByKey/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUserBackground({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUserBackground/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUserBackgroundByFbid({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUserBackgroundByFbid/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUserChat({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUserChat/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUserDashboard({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUserDashboard/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUserEvents({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUserEvents/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUserMilestones({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUserMilestones/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUserPoints({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUserPoints/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUserSignature({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUserSignature/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUserSignatureByFbid({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUserSignatureByFbid/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUserSnapshots({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUserSnapshots/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUserIdByFbid({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUserIdByFbid/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getUsersNextDiet({ data, pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getUsersNextDiet/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getWizardById({ idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getWizardById/' + idPost + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getWizardResponses({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getWizardResponses/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function getWizards({ pagination = null, relatedPost = null, createdAt = null, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/getWizards/' + pagination + '/' + relatedPost + '/' + createdAt + '/' + language, {
            method: 'GET',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setChallenge({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setChallenge/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setCompany({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setCompany/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setDailyRequirements({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setDailyRequirements/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setDiet({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setDiet/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setFoodTracking({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setFoodTracking/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setIADietQueue({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setIADietQueue/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setIngredient({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setIngredient/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setMilestone({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setMilestone/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setNextDiet({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setNextDiet/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setNutriChat({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setNutriChat/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setOorenjiLevel({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setOorenjiLevel/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setRecipe({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setRecipe/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setReferral({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setReferral/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setSlotRequirements({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setSlotRequirements/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setSnapshot({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setSnapshot/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setUserBackground({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setUserBackground/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setUserChat({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setUserChat/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setUserDashboard({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setUserDashboard/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setUserEvents({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setUserEvents/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setUserMilestone({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setUserMilestone/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setUserSignature({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setUserSignature/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setWizardResponse({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setWizardResponse/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function setTracking({ data, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/setTracking/' + language, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function transalateRecipes({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/transalateRecipes/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateChallenge({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateChallenge/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateCompany({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateCompany/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateDiet({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateDiet/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateFoodTracking({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateFoodTracking/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateIADietQueue({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateIADietQueue/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateIgrendient({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateIgrendient/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateMealtype({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateMealtype/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateMilestone({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateMilestone/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateNextDiet({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateNextDiet/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateNutriChat({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateNutriChat/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateOorenjiLevel({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateOorenjiLevel/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateOorenjiProgress({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateOorenjiProgress/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updatePopup({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updatePopup/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateRecipe({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateRecipe/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateRecipesTaken({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateRecipesTaken/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateReferral({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateReferral/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateTilteAndStepsRecipes({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateTilteAndStepsRecipes/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateTitleIntoIngredients({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateTitleIntoIngredients/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateTrackingIsActive({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateTrackingIsActive/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateTrackingValues({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateTrackingValues/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateUserBackground({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateUserBackground/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateUserChallenges({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateUserChallenges/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateUserChat({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateUserChat/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateUserDashboard({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateUserDashboard/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateUserEvents({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateUserEvents/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateUserMilestone({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateUserMilestone/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateUserProgress({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateUserProgress/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateUserSignature({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateUserSignature/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateWizard({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateWizard/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function updateFbIdFromRecipes({ data, idPost, language = 'default' }) {
    try {
        const response = await fetch(BASE_URL + '/updateFbIdFromRecipes/' + idPost + '/' + language, {
            method: 'PATCH',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function deleteChallenge({ idPost }) {
    try {
        const response = await fetch(BASE_URL + '/deleteChallenge/' + idPost, {
            method: 'DELETE',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function deleteDiet({ idPost }) {
    try {
        const response = await fetch(BASE_URL + '/deleteDiet/' + idPost, {
            method: 'DELETE',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function deleteFoodTracking({ idPost }) {
    try {
        const response = await fetch(BASE_URL + '/deleteFoodTracking/' + idPost, {
            method: 'DELETE',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function deleteIngredient({ idPost }) {
    try {
        const response = await fetch(BASE_URL + '/deleteIngredient/' + idPost, {
            method: 'DELETE',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function deleteMilestone({ idPost }) {
    try {
        const response = await fetch(BASE_URL + '/deleteMilestone/' + idPost, {
            method: 'DELETE',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function deleteNextDiet({ idPost }) {
    try {
        const response = await fetch(BASE_URL + '/deleteNextDiet/' + idPost, {
            method: 'DELETE',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function deleteRecipe({ idPost }) {
    try {
        const response = await fetch(BASE_URL + '/deleteRecipe/' + idPost, {
            method: 'DELETE',
            headers
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};

async function pay({ data }) {
    try {
        const response = await fetch(BASE_URL + '/pay', {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });

        return response.json();
    } catch (error) {
        return { statusCode: 500, message: error }
    }
};


export {
    getAdminById,
    getAllChallenges,
    getAllIngredients,
    getAllRecipes,
    getCalooPage,
    getChallengeById,
    getCompanies,
    getCompaniesLimit,
    getCompany,
    getCustomerNutriChat,
    getDietById,
    getDiets,
    getDietsLimit,
    getFeaturedRecipes,
    getFilteredRecipes,
    getFoodTrackings,
    getIADietQueue,
    getIngredientById,
    getIngredientsByStatus,
    getMealTypes,
    getMilestoneById,
    getMilestones,
    getMilestonesByDate,
    getMilestonesInChallenge,
    getModalPremium,
    getModalPremiumById,
    getNextDietByUserId,
    getNutriChat,
    getNutrichatsForNutritionist,
    getOorenjiLevelByLevel,
    getPopUps,
    getPromptByName,
    getRecipeByFbid,
    getRecipeById,
    getRecipesByPacks,
    getRecipesByUser,
    getRedisVersion,
    getReferalById,
    getTracking,
    getTrackingByKey,
    getUserBackground,
    getUserBackgroundByFbid,
    getUserChat,
    getUserDashboard,
    getUserEvents,
    getUserMilestones,
    getUserPoints,
    getUserSignature,
    getUserSignatureByFbid,
    getUserSnapshots,
    getUserIdByFbid,
    getUsersNextDiet,
    getWizardById,
    getWizardResponses,
    getWizards,
    setChallenge,
    setCompany,
    setDailyRequirements,
    setDiet,
    setFoodTracking,
    setIADietQueue,
    setIngredient,
    setMilestone,
    setNextDiet,
    setNutriChat,
    setOorenjiLevel,
    setRecipe,
    setReferral,
    setSlotRequirements,
    setSnapshot,
    setUserBackground,
    setUserChat,
    setUserDashboard,
    setUserEvents,
    setUserMilestone,
    setUserSignature,
    setWizardResponse,
    setTracking,
    transalateRecipes,
    updateChallenge,
    updateCompany,
    updateDiet,
    updateFoodTracking,
    updateIADietQueue,
    updateIgrendient,
    updateMealtype,
    updateMilestone,
    updateNextDiet,
    updateNutriChat,
    updateOorenjiLevel,
    updateOorenjiProgress,
    updatePopup,
    updateRecipe,
    updateRecipesTaken,
    updateReferral,
    updateTilteAndStepsRecipes,
    updateTitleIntoIngredients,
    updateTrackingIsActive,
    updateTrackingValues,
    updateUserBackground,
    updateUserChallenges,
    updateUserChat,
    updateUserDashboard,
    updateUserEvents,
    updateUserMilestone,
    updateUserProgress,
    updateUserSignature,
    updateWizard,
    updateFbIdFromRecipes,
    deleteChallenge,
    deleteDiet,
    deleteFoodTracking,
    deleteIngredient,
    deleteMilestone,
    deleteNextDiet,
    deleteRecipe,
    pay
};

